// extracted by mini-css-extract-plugin
export default {"footerButton":"Footer_footerButton__Fm-zJ"};